const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M344.616 31.839a9.981 9.981 0 0 0-17.017 7.074v53.242c-53.886 2.148-80.877 24.482-85.005 28.2a151.271 151.271 0 0 0-52.497 87.927 154.87 154.87 0 0 0-1.781 50.67l.007.058c.02.149.043.301.067.449l2.12 12.188a9.98 9.98 0 0 0 18.385 3.426l6.353-10.59c19.52-32.46 43.845-53.975 72.31-63.949a104.865 104.865 0 0 1 40.041-5.87v55.144a9.977 9.977 0 0 0 17.052 7.035l105.443-105.977c3.886-3.906 3.871-10.224-.035-14.11L344.616 31.839Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "translate(2 2) scale(.04415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.434 322.741c-5.507 0-9.978 4.467-9.978 9.978v42.173c-.015 16.522-13.408 29.914-29.934 29.934H49.89c-16.526-.02-29.914-13.412-29.934-29.934V137.169c.02-16.526 13.408-29.914 29.934-29.934h69.008a9.976 9.976 0 0 0 9.978-9.978c0-5.511-4.466-9.978-9.978-9.978H49.89C22.349 87.311.031 109.629 0 137.169v237.723c.031 27.537 22.349 49.855 49.89 49.89h326.632c27.541-.035 49.859-22.353 49.89-49.89v-42.173c0-5.511-4.467-9.978-9.978-9.978Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "translate(2 2) scale(.04415)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.e67af3194cb4b822165a4c8bab16d5d6.svg";
export { ForwardRef as ReactComponent };